'use client';

interface ProductInfoProps {
  name: string;
  description: string;
  features: string[];
  specs: {
    dimensions: {
      width?: number;
      seatWidth?: number;
      height?: number;
      depth?: number;
      maxDepth?: number;
      [key: string]: number | undefined;
    };
    materials: {
      body?: string;
      foot?: string;
      armrest?: string;
      [key: string]: string | undefined;
    };
  };
}

// Boyut adlarının Türkçe karşılıkları
const dimensionLabels: Record<string, string> = {
  width: 'Genişlik',
  seatWidth: 'Oturma Genişliği',
  height: 'Yükseklik',
  depth: 'Derinlik',
  maxDepth: 'Maksimum Derinlik',
  diameter: 'Çap',
  length: 'Uzunluk',
  weight: 'Ağırlık',
  capacity: 'Kapasite'
};

// Malzeme adlarının Türkçe karşılıkları
const materialLabels: Record<string, string> = {
  body: 'Gövde',
  foot: 'Ayak',
  armrest: 'Kolçak',
  frame: 'İskelet',
  upholstery: 'Döşeme',
  finish: 'Kaplama',
  seat: 'Oturma Yüzeyi',
  backrest: 'Sırt Desteği'
};

export function ProductInfo({ name, description, features, specs }: ProductInfoProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">{name}</h1>
      <div className="prose max-w-none mb-8">
        <p className="text-gray-600">{description}</p>
      </div>
      <div className="space-y-8">
        {/* Özellikler */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Özellikler</h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <svg
                  className="h-5 w-5 text-primary mr-2 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-gray-600">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
} 